import Vue from 'vue'
import Vuex from 'vuex'
import lang from './modules/lang'
import account from './modules/account'
import expireTime from './modules/expireTime'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    lang,
    account,
    expireTime,
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js